/* tslint:disable */
/* eslint-disable */
/**
 * Private UI API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: ${project.version}
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface DisableExtendedVersioningSettingsRequest
 */
export interface DisableExtendedVersioningSettingsRequest {
    /**
     * 
     * @type {boolean}
     * @memberof DisableExtendedVersioningSettingsRequest
     */
    disableExtendedLoaderVersioning?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof DisableExtendedVersioningSettingsRequest
     */
    disableExtendedFwVersioning?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof DisableExtendedVersioningSettingsRequest
     */
    disableExtendedUiVersioning?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof DisableExtendedVersioningSettingsRequest
     */
    disableExtendedCustomFw1Versioning?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof DisableExtendedVersioningSettingsRequest
     */
    disableExtendedCustomFw2Versioning?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof DisableExtendedVersioningSettingsRequest
     */
    disableExtendedCustomFw3Versioning?: boolean | null;
}

export function DisableExtendedVersioningSettingsRequestFromJSON(json: any): DisableExtendedVersioningSettingsRequest {
    return DisableExtendedVersioningSettingsRequestFromJSONTyped(json, false);
}

export function DisableExtendedVersioningSettingsRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): DisableExtendedVersioningSettingsRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'disableExtendedLoaderVersioning': !exists(json, 'disableExtendedLoaderVersioning') ? undefined : json['disableExtendedLoaderVersioning'],
        'disableExtendedFwVersioning': !exists(json, 'disableExtendedFwVersioning') ? undefined : json['disableExtendedFwVersioning'],
        'disableExtendedUiVersioning': !exists(json, 'disableExtendedUiVersioning') ? undefined : json['disableExtendedUiVersioning'],
        'disableExtendedCustomFw1Versioning': !exists(json, 'disableExtendedCustomFw1Versioning') ? undefined : json['disableExtendedCustomFw1Versioning'],
        'disableExtendedCustomFw2Versioning': !exists(json, 'disableExtendedCustomFw2Versioning') ? undefined : json['disableExtendedCustomFw2Versioning'],
        'disableExtendedCustomFw3Versioning': !exists(json, 'disableExtendedCustomFw3Versioning') ? undefined : json['disableExtendedCustomFw3Versioning'],
    };
}

export function DisableExtendedVersioningSettingsRequestToJSON(value?: DisableExtendedVersioningSettingsRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'disableExtendedLoaderVersioning': value.disableExtendedLoaderVersioning,
        'disableExtendedFwVersioning': value.disableExtendedFwVersioning,
        'disableExtendedUiVersioning': value.disableExtendedUiVersioning,
        'disableExtendedCustomFw1Versioning': value.disableExtendedCustomFw1Versioning,
        'disableExtendedCustomFw2Versioning': value.disableExtendedCustomFw2Versioning,
        'disableExtendedCustomFw3Versioning': value.disableExtendedCustomFw3Versioning,
    };
}

